import type { MessageBody, MessageConfig, MessageType } from './types'

export default function getMessageConfig({
  type,
  body,
}: {
  type: MessageType | null
  body: MessageBody | null
}): MessageConfig | null {
  if (type == null || body == null) {
    return null
  }

  // Since it's coming from the database model instance, we can assume it was validated at ingress point
  // eslint-disable-next-line local/no-new-type-assertions
  return { type, body } as MessageConfig
}
